module.exports = __webpack_public_path__ + "static/media/kongQiClassroom.a087f48d.png";